const RoundTypes = {
  roundRobin: "ROUND_ROBIN",
  elimination: "ELIMINATION",
};

export default RoundTypes;
